import styled, { css } from 'styled-components/macro';
import { MessageVariant, StyledMessageProps } from './message.types';

const iconRoles = {
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'error',
  pending: 'info',
} as const satisfies Record<MessageVariant, string>;

export const StyledMessage = styled.div<StyledMessageProps>`
  ${({ theme, $type }) => css`
    padding-block: ${theme.spacings.componentOnly};
    padding-inline: ${theme.spacings.s};
    display: flex;
    align-items: center;
    gap: ${theme.spacings.xs};
    color: ${theme.semantic.text.default};
    background-color: ${theme.semantic.bg.surface};
    border: 1px solid ${theme.semantic.border.default};
    border-radius: ${theme.radiuses.xs};
    box-shadow: ${theme.shadows.sm};
    user-select: none;
    width: max-content;
    max-width: 100%;

    & .svg-viewer {
      color: ${theme.semantic.icon[iconRoles[$type]]};
    }
  `};
`;
